import {isWithinDaysFromNow, isWithinYearsFromNow, formatDate} from '../DateUtil'
import Productable from '../concerns/Productable'

export default function Registration(lineItem) {
  const self = {
    sku: lineItem.sku,
    id: lineItem.id,
    title: lineItem.title,
    lineItem: lineItem
  }

  self.skuInstructorCourse = self.sku && self.sku.replace(/_INSC_REG/, '_INSC_FULL')

  self.variant_id_full = (products) => {
    const productFull = products.find((product) => product.sku == self.skuInstructorCourse)
    return productFull && productFull.variants && productFull.variants[0].id
  }

  self.section = (sections) => {
    return sections.find((section) => section.sku == self.skuInstructorCourse)
  }

  self.start_at = (sections) => {
    const section = self.section(sections)
    return section && section.start_at
  }

  return self
}
